import api from './api';

const plantillaService = {
  // ===== PLANTILLAS DE MENSAJE =====
  // Obtener todas las plantillas de mensaje
  getPlantillasMensaje: async () => {
    try {
      const response = await api.get('/plantillas-mensaje');
      return response.data;
    } catch (error) {
      console.error('Error al obtener plantillas de mensaje:', error);
      return [];
    }
  },
  
  // Obtener plantilla de mensaje por ID
  getPlantillaMensajeById: async (id) => {
    try {
      const response = await api.get(`/plantillas-mensaje/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener plantilla de mensaje:', error);
      throw error;
    }
  },
  
  // Crear nueva plantilla de mensaje
  createPlantillaMensaje: async (plantillaData) => {
    try {
      const response = await api.post('/plantillas-mensaje', plantillaData);
      return response.data;
    } catch (error) {
      console.error('Error al crear plantilla de mensaje:', error);
      throw error;
    }
  },
  
  // Actualizar plantilla de mensaje existente
  updatePlantillaMensaje: async (id, plantillaData) => {
    try {
      const response = await api.put(`/plantillas-mensaje/${id}`, plantillaData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar plantilla de mensaje:', error);
      throw error;
    }
  },
  
  // Eliminar plantilla de mensaje
  deletePlantillaMensaje: async (id) => {
    try {
      const response = await api.delete(`/plantillas-mensaje/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar plantilla de mensaje:', error);
      throw error;
    }
  },
  
  // Probar envío de plantilla de mensaje
  testPlantillaMensaje: async (id, datos) => {
    try {
      const response = await api.post(`/plantillas-mensaje/${id}/probar`, datos);
      return response.data;
    } catch (error) {
      console.error('Error al probar plantilla de mensaje:', error);
      throw error;
    }
  },
  
  // ===== PLANTILLAS DE DOCUMENTO =====
  // Obtener todas las plantillas de documento
getPlantillasDocumento: async (filtros = {}) => {
  try {
    // Agregar timestamp para evitar caché
    filtros._t = new Date().getTime();
    
 
    const response = await api.get('/plantillas-documento', { params: filtros });
 
    
    // Si no hay datos, hacer una consulta secundaria
    if (!response.data || !response.data.length) {
       
      const directQuery = await api.get('/plantillas-documento/debug-all');
   
    }
    
    return response.data;
  } catch (error) {
    console.error('Error al obtener plantillas de documento:', error);
    return [];
  }
},
  
  // Obtener plantilla de documento por ID
  getPlantillaDocumentoById: async (id) => {
    try {
      const response = await api.get(`/plantillas-documento/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener plantilla de documento:', error);
      throw error;
    }
  },
  
  // Crear nueva plantilla de documento
  createPlantillaDocumento: async (plantillaData) => {
    try {
      const response = await api.post('/plantillas-documento', plantillaData);
      return response.data;
    } catch (error) {
      console.error('Error al crear plantilla de documento:', error);
      throw error;
    }
  },
  
  // Actualizar plantilla de documento existente
  updatePlantillaDocumento: async (id, plantillaData) => {
    try {
      const response = await api.put(`/plantillas-documento/${id}`, plantillaData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar plantilla de documento:', error);
      throw error;
    }
  },
  
  // Eliminar plantilla de documento
  deletePlantillaDocumento: async (id) => {
    try {
      const response = await api.delete(`/plantillas-documento/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar plantilla de documento:', error);
      throw error;
    }
  },
  
  // Obtener plantillas por etapa
  getPlantillasDocumentoPorEtapa: async (etapaId) => {
    try {
      const response = await api.get(`/plantillas-documento/etapa/${etapaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener plantillas por etapa:', error);
      return [];
    }
  },
  
  // Obtener plantillas por especialidad
  getPlantillasDocumentoPorEspecialidad: async (especialidadId) => {
    try {
      const response = await api.get(`/plantillas-documento/especialidad/${especialidadId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener plantillas por especialidad:', error);
      return [];
    }
  },
  
  // Generar PDF a partir de una plantilla completada
  generarPDF: async (data) => {
    try {
      const response = await api.post('/plantillas-documento/generar-pdf', data);
      return response.data;
    } catch (error) {
      console.error('Error al generar PDF:', error);
      throw error;
    }
  },
  
  // Procesar variables en una plantilla
  procesarVariables: async (plantillaId, datos) => {
    try {
      const response = await api.post(`/plantillas-documento/${plantillaId}/procesar`, datos);
      return response.data;
    } catch (error) {
      console.error('Error al procesar variables:', error);
      throw error;
    }
  },
  
  // Duplicar una plantilla existente
  duplicarPlantilla: async (id) => {
    try {
      const response = await api.post(`/plantillas-documento/${id}/duplicar`);
      return response.data;
    } catch (error) {
      console.error('Error al duplicar plantilla:', error);
      throw error;
    }
  },
  
  // Asociar plantilla a una etapa
  asociarAEtapa: async (plantillaId, etapaId, requerido = false) => {
    try {
      const response = await api.post(`/plantillas-documento/${plantillaId}/asociar-etapa`, {
        etapa_id: etapaId,
        requerido_en_etapa: requerido
      });
      return response.data;
    } catch (error) {
      console.error('Error al asociar plantilla a etapa:', error);
      throw error;
    }
  },
  
  // Desasociar plantilla de una etapa
  desasociarDeEtapa: async (plantillaId, etapaId) => {
    try {
      const response = await api.delete(`/plantillas-documento/${plantillaId}/desasociar-etapa/${etapaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al desasociar plantilla de etapa:', error);
      throw error;
    }
  },
  
  // ===== MÉTODOS COMPARTIDOS =====
  // Obtener membretes
  getMembretes: async () => {
    try {
      const response = await api.get('/membretes');
      return response.data;   
    } catch (error) {
      console.error('Error al obtener membretes:', error);
      return []; 
    }
  },
  
  // Obtener categorías de documentos
  getCategorias: async () => {
    try {
      const response = await api.get('/categorias-documentos');
      return response.data;
    } catch (error) {
      console.error('Error al obtener categorías:', error);
      return [];
    }
  },
  
  // Obtener especialidades
  getEspecialidades: async () => {
    try {
      const response = await api.get('/especialidades');
      return response.data;
    } catch (error) {
      console.error('Error al obtener especialidades:', error);
      return [];
    }
  },
  
  // ===== MÉTODOS DE COMPATIBILIDAD (para no romper código existente) =====
  // Estos métodos llaman a los nuevos métodos específicos según corresponda
  
  // Obtener todas las plantillas (ahora redirecciona a plantillas de mensaje por compatibilidad)
  getPlantillas: async (filtros = {}) => {
    console.warn('Método getPlantillas() debe ser reemplazado por getPlantillasMensaje() o getPlantillasDocumento()');
    
    if (filtros && filtros.tipo === 'Formulario') {
      return plantillaService.getPlantillasDocumento(filtros);
    } else {
      return plantillaService.getPlantillasMensaje();
    }
  },
  
  // Obtener plantilla por ID
  getPlantillaById: async (id) => {
    console.warn('Método getPlantillaById() debe ser reemplazado por getPlantillaMensajeById() o getPlantillaDocumentoById()');
    try {
      return await plantillaService.getPlantillaMensajeById(id);
    } catch (error) {
      return await plantillaService.getPlantillaDocumentoById(id);
    }
  },
  
  // Crear plantilla (por defecto usa plantillas de documento/formulario)
  createPlantilla: async (data) => {
    console.warn('Método createPlantilla() debe ser reemplazado por createPlantillaMensaje() o createPlantillaDocumento()');
    
    if (data.tipo === 'Formulario') {
      return plantillaService.createPlantillaDocumento(data);
    } else {
      return plantillaService.createPlantillaMensaje(data);
    }
  },
  
  // Actualizar plantilla
  updatePlantilla: async (id, data) => {
    console.warn('Método updatePlantilla() debe ser reemplazado por updatePlantillaMensaje() o updatePlantillaDocumento()');
    
    if (data.tipo === 'Formulario') {
      return plantillaService.updatePlantillaDocumento(id, data);
    } else {
      return plantillaService.updatePlantillaMensaje(id, data);
    }
  },
  
  // Eliminar plantilla
  deletePlantilla: async (id) => {
    console.warn('Método deletePlantilla() debe ser reemplazado por deletePlantillaMensaje() o deletePlantillaDocumento()');
    try {
      return await plantillaService.deletePlantillaMensaje(id);
    } catch (error) {
      return await plantillaService.deletePlantillaDocumento(id);
    }
  },
  
  // Para compatibilidad con método anterior
  getPlantilla: async (id) => {
    return plantillaService.getPlantillaDocumentoById(id);
  },

  // MODIFICADO: Mejorado para manejar el error 404
  getByEspecialidad: async (especialidadId) => {
    try {
      // Intentar primero con ruta plantillas/especialidad
      const response = await api.get(`/plantillas/especialidad/${especialidadId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener plantillas por especialidad:', error);
      
      // Si la ruta anterior falla, intentar con ruta alternativa
      try {
        // Intentar con ruta plantillas-documento/especialidad como alternativa
        const altResponse = await api.get(`/plantillas-documento/especialidad/${especialidadId}`);
        return altResponse.data;
      } catch (altError) {
        console.warn('Rutas de API para plantillas por especialidad no implementadas');
       
      }
      
      // Devolver array vacío en caso de error para no romper la UI
      return { data: [] };
    }
  },
  getPlantillasPorEspecialidad: async (especialidadId) => {
  try {
    // Usa la ruta de formularios por especialidad que sí existe
    const response = await api.get(`/formularios/especialidad/${especialidadId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener plantillas por especialidad:', error);
    return []; // Retorna array vacío para que la aplicación siga funcionando
  }
},
};

export default plantillaService;